import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=20f0a1f8&isComponent&outputPath=components%2Findex590d50a3%2Findex"
import script from "./index.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex590d50a3%2Findex"
export * from "./index.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex590d50a3%2Findex"
import style0 from "./index.mpx?vue&type=style&index=0&id=20f0a1f8&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_590d50a3%22%7D&isComponent&outputPath=components%2Findex590d50a3%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports